import React, { useState } from 'react';
import { FaWhatsapp, FaEnvelope, FaLinkedin, FaGithub, FaTimes } from 'react-icons/fa';

const FloatingContact = () => {
  const [isOpen, setIsOpen] = useState(false);

  const contactOptions = [
    {
      icon: FaWhatsapp,
      label: 'WhatsApp',
      sublabel: 'Quick Response',
      href: 'https://wa.me/923424346670',
      color: '#25D366',
      hoverColor: '#20BD5A'
    },
    {
      icon: FaEnvelope,
      label: 'Email Me',
      sublabel: 'shahidhosseinoff@gmail.com',
      href: 'mailto:shahidhosseinoff@gmail.com',
      color: '#EA4335',
      hoverColor: '#D33828'
    },
    {
      icon: FaLinkedin,
      label: 'LinkedIn',
      sublabel: 'Connect',
      href: 'https://linkedin.com/in/shahid-ai-python',
      color: '#0A66C2',
      hoverColor: '#084E8A'
    },
    {
      icon: FaGithub,
      label: 'GitHub',
      sublabel: 'View Work',
      href: 'https://github.com/Shahid-Sheimi',
      color: '#ffffff',
      hoverColor: '#e0e0e0'
    }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contacts');
    if (element) {
      window.scrollTo({ top: element.offsetTop - 80, behavior: 'smooth' });
    }
    setIsOpen(false);
  };

  return (
    <div className="floating-contact-container">
      {/* Toggle Button */}
      <button 
        className={`floating-toggle ${isOpen ? 'active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Contact options"
      >
        {isOpen ? <FaTimes /> : <FaEnvelope />}
      </button>

      {/* Contact Options */}
      <div className={`floating-options ${isOpen ? 'show' : ''}`}>
        {contactOptions.map((option, index) => (
          <a
            key={index}
            href={option.href}
            target="_blank"
            rel="noopener noreferrer"
            className="floating-option"
            style={{ 
              '--option-color': option.color,
              '--option-hover': option.hoverColor
            }}
            title={`${option.label} - ${option.sublabel}`}
          >
            <option.icon />
            <span className="floating-option-label">{option.label}</span>
          </a>
        ))}
        
        {/* Form Option */}
        <button 
          onClick={scrollToContact}
          className="floating-option form-option"
          title="Send message via form"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"/>
          </svg>
          <span className="floating-option-label">Message Form</span>
        </button>
      </div>

      <style>{`
        .floating-contact-container {
          position: fixed;
          bottom: 30px;
          right: 30px;
          z-index: 9999;
        }

        .floating-toggle {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: linear-gradient(135deg, #00c6ff, #0072ff);
          border: none;
          color: white;
          font-size: 24px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 25px rgba(0, 114, 255, 0.4);
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          z-index: 100;
        }

        .floating-toggle:hover {
          transform: scale(1.1);
          box-shadow: 0 12px 35px rgba(0, 114, 255, 0.5);
        }

        .floating-toggle.active {
          transform: rotate(45deg);
          background: linear-gradient(135deg, #ff4757, #ff6b7a);
          box-shadow: 0 8px 25px rgba(255, 71, 87, 0.4);
        }

        .floating-options {
          position: absolute;
          bottom: 80px;
          right: 0;
          display: flex;
          flex-direction: column;
          gap: 12px;
          opacity: 0;
          visibility: hidden;
          transform: translateY(20px) scale(0.9);
          transition: all 0.3s ease;
        }

        .floating-options.show {
          opacity: 1;
          visibility: visible;
          transform: translateY(0) scale(1);
        }

        .floating-option {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 20px;
          background: rgba(15, 23, 42, 0.95);
          border-radius: 50px;
          color: var(--option-color, #fff);
          text-decoration: none;
          font-size: 14px;
          font-weight: 500;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
          border: 1px solid rgba(255, 255, 255, 0.1);
          min-width: 160px;
          justify-content: flex-start;
        }

        .floating-option:hover {
          background: rgba(30, 41, 59, 0.98);
          transform: translateX(-5px);
          border-color: var(--option-color);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
        }

        .floating-option svg, .floating-option .react-icons {
          font-size: 18px;
          flex-shrink: 0;
        }

        .floating-option-label {
          white-space: nowrap;
          color: rgba(255, 255, 255, 0.9);
        }

        .form-option {
          background: linear-gradient(135deg, rgba(0, 198, 255, 0.2), rgba(0, 114, 255, 0.2));
          border-color: rgba(0, 198, 255, 0.3);
          color: #00c6ff;
        }

        .form-option:hover {
          background: linear-gradient(135deg, rgba(0, 198, 255, 0.3), rgba(0, 114, 255, 0.3));
          border-color: #00c6ff;
        }

        /* Pulse animation for toggle */
        @keyframes pulse-ring {
          0% {
            box-shadow: 0 0 0 0 rgba(0, 114, 255, 0.5);
          }
          70% {
            box-shadow: 0 0 0 15px rgba(0, 114, 255, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(0, 114, 255, 0);
          }
        }

        .floating-toggle:not(.active) {
          animation: pulse-ring 2s infinite;
        }

        /* Mobile responsiveness */
        @media (max-width: 576px) {
          .floating-contact-container {
            bottom: 20px;
            right: 20px;
          }

          .floating-toggle {
            width: 55px;
            height: 55px;
            font-size: 22px;
          }

          .floating-options {
            bottom: 70px;
            right: -10px;
          }

          .floating-option {
            padding: 10px 16px;
            min-width: 150px;
          }
        }
      `}</style>
    </div>
  );
};

export default FloatingContact;
